import { StyleSheet } from 'react-native';

// Espelham as constantes de layout da HomeScreen (mantidas em sincronia).
const CARD_GAP = 12;
const RESOLVER_TILE_WIDTH = 130;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    paddingTop: 50,
    paddingBottom: 8,
    paddingHorizontal: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
  },
  headerTop: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  headerTitleContainer: {
    flexDirection: 'column',
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: '800',
    letterSpacing: -0.5,
  },
  // Badge compacto de estatísticas
  statsCompact: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.12)',
    borderRadius: 6,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginTop: 6,
    alignSelf: 'flex-start',
  },
  statCompactItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  statCompactNumber: {
    fontSize: 13,
    fontWeight: '700',
    color: '#FFFFFF',
    marginRight: 3,
  },
  statCompactLabel: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.7)',
  },
  statCompactDivider: {
    width: 1,
    height: 12,
    backgroundColor: 'rgba(255,255,255,0.25)',
    marginHorizontal: 10,
  },
  profileButton: {
    padding: 4,
  },
  enterButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: 'rgba(255,255,255,0.15)',
    borderRadius: 20,
  },
  enterButtonText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
  },
  profileAvatarContainer: {
    alignItems: 'center',
  },
  profileAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: 'rgba(255,255,255,0.2)',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: 'rgba(255,255,255,0.3)',
  },
  profileAvatarImage: {
    width: 48,
    height: 48,
    borderRadius: 24,
    borderWidth: 2,
    borderColor: 'rgba(255,255,255,0.5)',
  },
  profileAvatarText: {
    fontSize: 20,
  },
  profileAreaContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  profileStatsColumn: {
    alignItems: 'flex-end',
    marginRight: 8,
  },
  rankingBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.4)',
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 12,
    marginBottom: 3,
  },
  rankingBadgeIcon: {
    fontSize: 14,
    marginRight: 3,
  },
  rankingBadgeText: {
    fontSize: 12,
    fontWeight: '700',
    color: '#FFD700',
  },
  xpPill: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(139, 92, 246, 0.4)',
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 12,
  },
  xpPillIcon: {
    fontSize: 11,
    marginRight: 3,
  },
  xpPillText: {
    fontSize: 11,
    fontWeight: '700',
    color: '#E9D5FF',
  },
  content: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  // ========== GAMIFICATION SECTION ==========
  gamificationSection: {
    marginBottom: 16,
    gap: 12,
  },
  gamificationRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  pillBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    borderRadius: 18,
    paddingHorizontal: 9,
    paddingVertical: 5,
  },
  pillIcon: {
    fontSize: 13,
  },
  pillText: {
    fontSize: 11,
    fontWeight: '600',
  },
  pillTextSecondary: {
    fontSize: 10,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: '600',
    marginTop: 16,
    marginBottom: 10,
    marginLeft: 8,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  studySectionTitle: {
    fontSize: 14,
    fontWeight: '700',
    marginTop: 36,
    marginBottom: 16,
  },
  studyContinuousTitle: {
    fontSize: 14,
    fontWeight: '700',
  },
  resolverQuestoesHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 36,
    marginBottom: 16,
  },
  resolverQuestoesTitle: {
    fontSize: 14,
    fontWeight: '700',
  },
  resolverHero: {
    height: 332,
    marginTop: 36,
    marginBottom: 24,
    position: 'relative',
  },
  resolverHeroLight: {
    shadowColor: '#7C3AED',
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.16,
    shadowRadius: 18,
    elevation: 5,
  },
  resolverHeroShape: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: 286,
  },
  resolverDots: {
    position: 'absolute',
    top: 12,
    right: 24,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 9,
    zIndex: 3,
  },
  resolverDot: {
    width: 9,
    height: 9,
    borderRadius: 5,
    backgroundColor: '#FFFFFF',
  },
  resolverDotLight: {
    backgroundColor: '#6C3BFF',
  },
  resolverDotDim: {
    opacity: 0.35,
  },
  resolverHeroLabel: {
    position: 'absolute',
    left: 15,
    top: 60,
    fontSize: 12,
    lineHeight: 12,
    color: 'rgba(255,255,255,0.78)',
    zIndex: 3,
  },
  resolverHeroLabelLight: {
    color: '#6C3BFF',
  },
  resolverHeroTitle: {
    position: 'absolute',
    left: 15,
    top: 94,
    fontSize: 22,
    lineHeight: 26,
    fontWeight: '800',
    color: '#FFFFFF',
    zIndex: 3,
  },
  resolverHeroTitleLight: {
    color: '#111827',
  },
  resolverSlides: {
    position: 'absolute',
    left: -16,
    right: -16,
    top: 132,
    height: 190,
    zIndex: 4,
    overflow: 'visible',
  },
  resolverSlidesContent: {
    paddingLeft: 31,
    paddingRight: 31,
    overflow: 'visible',
  },
  resolverSlideCard: {
    width: RESOLVER_TILE_WIDTH,
    height: 172,
    borderRadius: 20,
    marginRight: 10,
    backgroundColor: '#252832',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.24,
    shadowRadius: 16,
    elevation: 10,
  },
  resolverSlideCardDisabled: {
    opacity: 0.45,
  },
  resolverSlideGradient: {
    flex: 1,
    padding: 10,
    justifyContent: 'space-between',
    borderRadius: 20,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.18)',
  },
  resolverCardGlow: {
    position: 'absolute',
    right: -30,
    top: -20,
    width: 92,
    height: 92,
    borderRadius: 46,
    backgroundColor: 'rgba(255,255,255,0.16)',
  },
  resolverCardIconWrap: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: 'rgba(0,0,0,0.55)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  resolverCardIcon: {
    width: 17,
    height: 17,
    // `tintColor` NÃO fica aqui — é prop do expo-image (ver o Image no HomeScreen).
  },
  resolverCardMeta: {
    gap: 4,
  },
  resolverCardKind: {
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(255,255,255,0.82)',
  },
  resolverCardTitle: {
    fontSize: 15,
    lineHeight: 18,
    fontWeight: '800',
    color: '#FFFFFF',
  },
  resolverCardSubtitle: {
    fontSize: 11,
    lineHeight: 13,
    color: 'rgba(255,255,255,0.72)',
  },
  // ========== PREMIUM CARDS - Estilo ProfileScreen ==========
  premiumCardsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: CARD_GAP,
  },
  premiumCard: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    padding: 14,
    gap: 12,
  },
  premiumIconWrapper: {
    width: 44,
    height: 44,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  premiumIconWrapperLight: {
    width: 28,
    height: 28,
    borderRadius: 0,
    backgroundColor: 'transparent',
  },
  premiumIconImage: {
    width: 24,
    height: 24,
  },
  premiumIconImageLight: {
    width: 25,
    height: 25,
  },
  premiumIcon: {
    fontSize: 20,
  },
  premiumIconLight: {
    color: '#6C3BFF',
    fontWeight: '800',
  },
  premiumCardContent: {
    flex: 1,
  },
  premiumTitle: {
    fontSize: 15,
    fontWeight: '700',
  },
  premiumSubtitle: {
    fontSize: 10,
    marginTop: 2,
  },
  premiumArrow: {
    fontSize: 20,
    fontWeight: '300',
  },
  // ========== FIM PREMIUM CARDS ==========

  // ========== MENU CARD GROUP - Estilo ProfileScreen ==========
  menuCardGroup: {
    borderRadius: 12,
    overflow: 'hidden',
    marginBottom: 16,
  },

  // ========== MENU BUTTONS - Estilo ProfileScreen ==========
  menuButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 14,
    backgroundColor: 'transparent',
  },
  menuButtonFirst: {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  menuButtonLast: {
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
  },
  menuButtonBorder: {
    borderBottomWidth: 1,
  },
  menuButtonDisabled: {
    opacity: 0.5,
  },
  menuIconWrapper: {
    width: 40,
    height: 40,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  menuIcon: {
    fontSize: 18,
  },
  menuTextContainer: {
    flex: 1,
  },
  menuTitle: {
    fontSize: 15,
    fontWeight: '600',
  },
  menuSubtitle: {
    fontSize: 12,
    marginTop: 2,
  },
  menuArrow: {
    fontSize: 20,
    fontWeight: '300',
    marginLeft: 8,
  },
  // ========== FIM MENU BUTTONS ==========

  // ========== SEÇÃO ESTUDO CONTÍNUO ==========
  studySection: {
    marginTop: 24,
  },
  studySectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  studySectionLink: {
    fontSize: 14,
    fontWeight: '600',
    color: '#3B18C3',
  },
  studyCard: {
    borderRadius: 12,
    padding: 10,
    borderWidth: 1,
  },
  studyStatsRow: {
    flexDirection: 'row',
    marginBottom: 10,
  },
  studyStatBox: {
    flex: 1,
    padding: 6,
    borderRadius: 8,
    borderWidth: 1,
    marginRight: 8,
  },
  studyStatRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 3,
  },
  studyStatIcon: {
    width: 20,
    height: 20,
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 6,
  },
  studyStatNumber: {
    fontSize: 16,
    fontWeight: '800',
  },
  studyStatLabel: {
    fontSize: 9,
  },
  weekDaysContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingVertical: 10,
    borderRadius: 8,
    borderWidth: 1,
    marginBottom: 8,
  },
  weekDayItem: {
    alignItems: 'center',
  },
  weekDayIcon: {
    fontSize: 14,
    marginBottom: 2,
  },
  weekDayText: {
    fontSize: 10,
  },
  studyGoalBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    borderRadius: 8,
  },
  studyGoalText: {
    flex: 1,
    fontSize: 11,
    fontWeight: '500',
    lineHeight: 15,
  },
  studyGoalBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
    backgroundColor: 'rgba(0,0,0,0.05)',
  },
  studyGoalBadgeText: {
    fontSize: 13,
    fontWeight: '600',
  },
  // ========== FIM SEÇÃO ESTUDO CONTÍNUO ==========

  footer: {
    height: 80, // Espaço para a BottomTabBar
  },
});
